import React, { useEffect } from 'react';
import { Link } from 'react-router';
import { LogOut } from 'lucide-react';
import { useUser } from '../contexts/UserContext';
import { LscLogo } from './components/LscLogo';
import LscFooter from './components/LscFooter';
import { lscPath } from './routing';
import { legalPageUrl } from '../legal/legalLinks';

export type LscMarketingLayoutProps = {
  children: React.ReactNode;
};

const LscMarketingLayout: React.FC<LscMarketingLayoutProps> = ({ children }) => {
  const { user, logout } = useUser();

  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <div
      className="min-h-screen bg-secondary-900 text-white flex flex-col"
      data-testid="lsc-marketing-layout"
    >
      <header className="border-b border-secondary-700 bg-secondary-900/95 sticky top-0 z-20">
        <div className="w-full px-6 py-4 flex flex-wrap items-center justify-between gap-3">
          <Link to={lscPath()} aria-label="League Stream Center home" data-testid="marketing-brand-link">
            <LscLogo variant="nav" />
          </Link>
          <div className="flex flex-wrap items-center gap-3">
            {user ? (
              <>
                <Link to={lscPath('/leagues')} className="btn-primary text-sm">
                  Open Stream Center
                </Link>
                <Link
                  to="/studio"
                  className="text-sm font-medium text-[#a78bfa] hover:text-[#c4b5fd]"
                  data-testid="marketing-rtts-nav-link"
                >
                  Scoutlytics Studio
                </Link>
                <button
                  type="button"
                  onClick={() => logout()}
                  className="inline-flex items-center gap-2 text-sm text-secondary-400 hover:text-red-300"
                >
                  <LogOut className="h-4 w-4" aria-hidden />
                  Sign out
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/studio"
                  className="text-sm font-medium text-[#a78bfa] hover:text-[#c4b5fd]"
                  data-testid="marketing-rtts-nav-link"
                >
                  Scoutlytics Studio
                </Link>
                <Link to={lscPath('/leagues')} className="text-sm text-primary-300 hover:text-primary-200">
                  Sign in
                </Link>
              </>
            )}
            <a
              href={legalPageUrl('terms')}
              className="text-xs text-secondary-500 hover:text-primary-300"
            >
              Terms
            </a>
            <a
              href={legalPageUrl('privacy')}
              className="text-xs text-secondary-500 hover:text-primary-300"
            >
              Privacy
            </a>
          </div>
        </div>
      </header>

      <main className="flex-1">{children}</main>
      <LscFooter />
    </div>
  );
};

export default LscMarketingLayout;
